import React, { useState } from 'react';

const BrandingServices = () => {
  const [activeTab, setActiveTab] = useState(0);
  
  const services = [
    {
      id: 1,
      title: "Brand Identity Development",
      description: "Your brand identity is how the world sees and remembers your business.",
      features: [
        "Define your brand voice, personality & values",
        "Create a color palette, typography & brand guidelines",
        "Develop a consistent brand strategy for all platforms"
      ],
      cta: "Build a Unique & Recognizable Brand Identity Today!"
    },
    {
      id: 2,
      title: "Logo Design",
      description: "Your logo is the visual foundation of your brand. It should be memorable, versatile, and timeless.",
      features: [
        "Custom logo concepts designed from scratch",
        "Multiple variations for web, print & merchandise",
        "High-resolution files in JPEG, PNG, SVG, AI & PDF formats"
      ],
      cta: "Get a Logo That Represents Your Business Perfectly!"
    },
    {
      id: 3,
      title: "Printing Materials & Marketing Collateral",
      description: "Printed materials strengthen your brand presence and create a professional image.",
      features: [
        "Business Cards – First impressions matter",
        "Brochures & Flyers – Inform & attract customers",
        "Letterheads & Envelopes – Keep branding consistent",
        "Posters & Banners – High-quality, attention-grabbing designs",
        "Product Packaging & Labels – Branded for maximum impact"
      ],
      cta: "Stand Out with Professionally Designed Print Materials!"
    },
    {
      id: 4,
      title: "Brand Launch & Rebranding",
      description: "Whether you're launching a new brand or refreshing your current one, we ensure a smooth transition and impactful debut.",
      features: [
        "Create launch strategies & marketing plans",
        "Announce your brand with press releases & PR campaigns",
        "Develop social media & advertising materials for maximum exposure"
      ],
      cta: "Make a Bold Entrance into the Market with a Strong Brand Launch!"
    }
  ];

  return (
    <div className="bg-black py-12 px-4 text-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold mb-8 flex items-center">
          <span className="bg-yellow-500 p-2 rounded-full mr-3 text-xl text-black">!</span>
          Our Complete Branding Services
        </h2>

        <div className="mb-6 flex flex-wrap gap-2">
          {services.map((service, idx) => (
            <button
              key={service.id}
              onClick={() => setActiveTab(idx)}
              className={`py-2 px-4 rounded-lg font-medium transition ${
                activeTab === idx 
                  ? "bg-yellow-500 text-black" 
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
            >
              {service.id} {service.title}
            </button>
          ))}
        </div>

        <div className="bg-gray-900 border border-yellow-500 p-6 rounded-lg">
          <h3 className="text-2xl font-bold mb-2 text-yellow-500">{services[activeTab].title}</h3>
          <p className="text-gray-300 mb-6">{services[activeTab].description}</p>
          
          <div className="mb-6">
            <h4 className="font-semibold text-lg text-yellow-500 mb-3">
              • {activeTab === 2 ? "We Design & Print" : activeTab === 3 ? "Brand Launch Services" : "What We Offer"}
            </h4>
            <ul className="space-y-3">
              {services[activeTab].features.map((feature, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="text-yellow-500 mr-2 mt-1 flex-shrink-0 text-lg font-bold">✓</span>
                  <span className="text-gray-300">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="text-center">
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandingServices;